import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Row, Col, Button, Label, UncontrolledTooltip, UncontrolledAlert } from 'reactstrap';
import { SelectField, ResourceSelect } from '@availity/select';
import {
  Field,
  Checkbox,
  CheckboxGroup
} from '@availity/form';
import '@availity/yup'
import { DateField } from '@availity/date';
import { Navigate } from 'react-router-dom';
import * as yup from 'yup';
import moment from 'moment';
import PropTypes from 'prop-types';
import axios from 'axios';
import AvApi from '@availity/api-axios';

import housingstore from '../stores/housingstore';
import ProgressValidatedForm from '../../Common/components/ProgressValidatedForm';
import withNavigate from '../../Common/components/withNavigate';

@observer
class SignatureComponent extends Component {
  
  constructor(props) {
    super(props);

    this.state = {
      // Navigation back
      redirectToTransportation: false,
      redirectToAHAHRap: false,
      
      // Navigation to Next
      redirectToDocumentation: false,

      userInput: '',
      enableProviderAgency: false,
      showInfo: false,
      redirectToLandingPage: false,
    }

    if(window.performance) {
			if(performance.navigation.type == 1) {
        housingstore.resetSupportiveHousingPage();
				window.location.href = '#';
			}
		}
  }

  componentWillMount() {
    
    const {memberInfo} = housingstore;
    const {isHomeless, isEnrolleeEligibleForAHAH} = memberInfo;

    if (
      isHomeless === 'Yes' &&
      isEnrolleeEligibleForAHAH === 'Yes' &&
      housingstore.getSupportiveHousingRouteStatus('/ahah-rap') !== 'completed'
    ) {
      housingstore.resetSupportiveHousingPage();
      housingstore.resetSupportiveHousingRoutesStatus();
      this.setState({ redirectToLandingPage: true });
    } else if (housingstore.getSupportiveHousingRouteStatus('/transportationinformation') !== 'completed') {
      housingstore.resetSupportiveHousingPage();
      housingstore.resetSupportiveHousingRoutesStatus();
      this.setState({ redirectToLandingPage: true });
    } else {
      if (
        housingstore.getSupportiveHousingRouteStatus('/signature') !== 'completed' &&
        housingstore.getSupportiveHousingRouteStatus('/signature') !== 'active'
      ) {
        housingstore.setSupportiveHousingPageStatus('#signature', 'active');
        housingstore.setSupportiveHousingRouteStatus('/signature', 'active');
      }
    }
  }

  componentDidMount() {
    window.onpopstate = () => {
      this.props.navigate(1); 
    }
  }

  setReporterFields = event => {
    const { name, value } = event.target;
    housingstore.setAssessmentReporter(name, value);
  }

  setReporterDate = value => {
    housingstore.setAssessmentReporterDate(value);
  }

  setSupervisorFields = event => {
    const { name, value } = event.target;
    housingstore.setAssessmentSupervisor(name, value);
  }

  setSupervisorDate = value => {
    housingstore.setAssessmentSupervisorDate(value);
  }

  setEnrolleeFields = event => {
    const { name, value } = event.target;
    housingstore.setEnrolleeInfo(name, value);
  }

  setEnrolleeDate = value => {
    housingstore.setEnrolleeInfoDate(value);
  }

  setTimeConsentReceived = event => {
    const { value } = event.target;
    housingstore.setTimeConsentReceived(value);
  }

  setAssessmentCat = value => {
    housingstore.setAssessmentCategories(value);
  }

  setSignatureCat = value => {
    housingstore.setSignatureCategories(value);
  }

  setValidation = value => {
    if(value === undefined || value && value._i === '' || value && value._i === undefined) {  // No value entered or blank
       if(moment(value).isAfter(new Date())) {
         return 2;
       }
      return 1;
    } 
    if (value === '') {
      return 2;
    }
    return 0;      // Tell user to leave field blank or enter correct date format
  }
  
  goBack = () => {
    const { memberInfo } = housingstore;
    const { isHomeless, isEnrolleeEligibleForAHAH } = memberInfo;

    if (isHomeless === 'Yes' && isEnrolleeEligibleForAHAH === 'Yes') {
      housingstore.setSupportiveHousingPageStatus('#ahah-rap', 'active');
      housingstore.setSupportiveHousingRouteStatus('/ahah-rap', 'active');
      this.setState({ redirectToAHAHRap: true })
    } else {
      housingstore.setSupportiveHousingPageStatus('#housingassessment', 'active');
      housingstore.setSupportiveHousingRouteStatus('/transportationinformation', 'active');
      this.setState({ redirectToTransportation: true })
    }

    housingstore.setSupportiveHousingPageStatus('#signature', 'disabled');
    housingstore.setSupportiveHousingRouteStatus('/signature', 'inactive');
  }

  submit = (pendingRoute = '/documentation') => {
    housingstore.setSupportiveHousingPageStatus('#signature', 'active');
    housingstore.setSupportiveHousingRouteStatus('/signature', 'completed');
    if (pendingRoute === '/documentation') {
      this.setState({ redirectToDocumentation: true })
      return;
    }
    this.props.navigate(pendingRoute);
  }

  onChangeProvAgencyName = (selectedProvAgencyName) => {
    const { attachments = [], assessmentReporter } = housingstore;
    const { providerAgency } = assessmentReporter;

    if (attachments?.length && providerAgency?.label !== selectedProvAgencyName?.label){
      housingstore.resetAllAttachments();
      this.setState({showInfo: true});
    }
		if (selectedProvAgencyName) {
      housingstore.setAssessmentReporter('providerAgencyField', selectedProvAgencyName);
		}
	}

  componentDidMount() {
		axios.post('/SupportiveHousingAssessment/EN/api/v1/provconn/provider/agency/lookup',
			{
				q: "verify",
				limit: 1,
				offset: 0,
				searchKey: "verify"
			})
				.then(res => {
					this.setState({ enableProviderAgency: true });
				}).catch(error => {
					if(error.response.status === 404){
						this.setState({ enableProviderAgency: false });
					}
				});
		window.onpopstate = () => {
			this.props.navigate(1);
		}
	}

  render() {

    const { userAgent } = navigator;

    const { 
      redirectToTransportation,
      redirectToAHAHRap,
      redirectToDocumentation, 
      enableProviderAgency, 
      userInput,
      showInfo ,
      redirectToLandingPage,
    } = this.state;

    const { 
      assessmentReporter,
      assessmentSupervisor,
      enrolleeInformation,
      assessmentCategories,
      signatureCategories,
      supportiveHousingPagesAHAH, 
      supportiveHousingPagesNoAHAH,
      memberInfo
    } = housingstore;
    
    const {
      reporterLast,
      reporterFirst,
      positionCred,
      providerAgency,
      reporterDate,
      reporterEmail,
      reporterPhone
    } = assessmentReporter;

    const {
      supervisorLast,
      supervisorFirst,
      supervisorPosCred,
      supervisorDate
    } = assessmentSupervisor

    const {
      enrolleeLast,
      enrolleeFirst,
      enrolleeDate,
      enrolleeNotes,
      enrolleeConsentReceived
    } = enrolleeInformation;

    const { isHomeless, isEnrolleeEligibleForAHAH } = memberInfo;

    const supportiveHousingPages = (isHomeless === 'Yes' && isEnrolleeEligibleForAHAH === 'Yes' ? supportiveHousingPagesAHAH : supportiveHousingPagesNoAHAH);

    if (redirectToTransportation) {
      return <Navigate to='/transportationinformation' />
    }

    if (redirectToAHAHRap) {
      return <Navigate to='/ahah-rap' />
    }

    if(redirectToDocumentation) {
      return <Navigate to="/documentation" />
    }

    if(redirectToLandingPage) {
      return <Navigate to="/" />
    }

    const provAgencyNameApi = new AvApi({
			api: '',
			url: '/SupportiveHousingAssessment/EN/api/v1/provconn/provider/agency/lookup',
			transformRequest: (options) => JSON.stringify(options),
		});

    const minFields = (isHomeless === 'Yes' && isEnrolleeEligibleForAHAH === 'Yes') ? 3 : 2;

    return (
      <>
        <div className="border-form">
          <div className='spacer-50' />

          <ProgressValidatedForm 
            pages={supportiveHousingPages}
            enableReinitialize
            initialValues={{
              reporterLastField: reporterLast,
              reporterFirstField: reporterFirst,
              positionCredField: positionCred,
              providerAgencyField: providerAgency,
              reporterDateField: reporterDate,
              reporterEmailField: reporterEmail,
              reporterPhoneField: reporterPhone,
              supervisorLastField: supervisorLast,
              supervisorFirstField: supervisorFirst,
              supervisorPosCredField: supervisorPosCred,
              supervisorDateField: supervisorDate,
              enrolleeLastField: enrolleeLast,
              enrolleeFirstField: enrolleeFirst,
              enrolleeDateField: enrolleeDate,
              enrolleeConsentReceivedField: enrolleeConsentReceived,
              signatureCheck: signatureCategories.map(x => x),
              assessmentCheck: assessmentCategories.map(x => x),
              enrolleeNotesField: enrolleeNotes
            }}
            onSubmit={this.submit}
            validationSchema={yup.object().shape({
              reporterLastField: yup.string()
                .matches(/^[A-Za-z0-9 \',\^\-&ÄäÖöÜü]+$/, 'Reporter Last Name should be alpha-numeric.')
                .required('Assessment Reporter Last Name is required'),
              reporterFirstField: yup.string()
                .matches(/^[A-Za-z0-9 \',\^\-&ÄäÖöÜü]+$/, 'Reporter First Name should be alpha-numeric.')
                .required('Assessment Reporter First Name is required'),
              positionCredField: yup.string().required('Report Position/Credentials is required'),
              providerAgencyField: enableProviderAgency ? yup.object().required('Provider Agency Name is required.') : yup.string().required('Provider Agency Name is required'),
              reporterDateField: yup.date()
                .max(moment().format('MM/DD/YYYY'), 'Date cannot be in the future')
                .required('Date is required')
                .typeError('Invalid Date'),
              reporterEmailField: yup.string()
                .required('Please enter reporter email address'),
              reporterPhoneField: yup.string()
                .matches(/^\d{10}$/, 'Phone number must be 10 digits with no hypens')
                .required('Please enter reporter phone number'),
              supervisorLastField: yup.string()
                .matches(/^[A-Za-z0-9 \',\^\-&ÄäÖöÜü]+$/, 'Supervisor Last Name should be alpha-numeric.'),
              supervisorFirstField: yup.string()
                .matches(/^[A-Za-z0-9 \',\^\-&ÄäÖöÜü]+$/, 'Supervisor First Name should be alpha-numeric.'),
              supervisorDateField: yup.lazy((value) => {
                switch(this.setValidation(value)) {
                  case 1:
                    return yup
                    .string()
                    .optional()
                    .nullable()
                    .typeError('Please enter a correct date using the date picker or leave this field empty');
                  case 2:
                    return yup.date()
                            .max(moment().format('MM/DD/YYYY'), 'Date cannot be in the future')
                            .typeError('')
                  default:
                    return yup.date()
                    .max(moment().format('MM/DD/YYYY'), 'Date cannot be in the future')
                    .typeError('Please enter date using date picker')
                }
              }),
              enrolleeLastField: yup.string()
                .matches(/^[A-Za-z0-9 \',\^\-&ÄäÖöÜü]+$/, 'Enrollee Last Name should be alpha-numeric.')
                .required('Enrollee Consent Last Name is required'),
              enrolleeFirstField: yup.string()
                .matches(/^[A-Za-z0-9 \',\^\-&ÄäÖöÜü]+$/, 'Enrollee First Name should be alpha-numeric.')
                .required('Enrollee Consent First Name is required'),
              enrolleeDateField: yup.date()
                .max(moment().format('MM/DD/YYYY'), 'Date cannot be in the future')
                .required('Enrollee Consent Date is required')
                .typeError('Invalid Date'),
              enrolleeConsentReceivedField: yup.string().required('Time Consent is required'),
              signatureCheck: yup.array()
                .min(minFields, 'Please select the required fields before continuing!')
                .isRequired(true, 'Please select an option before continuing!')
                .typeError('Please select an option before continuing!'),
              assessmentCheck: yup.array()
                .min(1, "Please select the required field before continuing!")
                .isRequired(true, 'Please select an option before continuing!')
                .typeError('Please select an option before continuing!')
            })}
          >
            <small className="required-fields">*required fields</small>
            <div className="spacer" />
            <h2 className="poppinsH2">
              Signatures
            </h2>
            <em>
              <small className="label-font">Please fill out to the best of your ability.</small>
            </em>
            <div className="spacer-48" />
            {showInfo  &&
							<Row className="pl-32 mt-3">
								<Col>
									<UncontrolledAlert color='danger' fade>
										<strong>
											Change in Provider Agency required all the docs to upload again..!
										</strong>
									</UncontrolledAlert>
								</Col>
							</Row>
						}
            <div>
              <h5 className="poppinsH5">
                Assessment Reporter
              </h5>
              <Row>
                <Col sm="4">
                  <Label className="label-font" htmlFor="reporterLast">
                    Last Name*
                  </Label>
                  <Field
                    type="text"
                    id="reporterLast"
                    name="reporterLastField"
                    className="straighten-borders"
                    value={reporterLast}
                    onChange={this.setReporterFields}
                    maxLength={50}
                  />
                </Col>
                <Col sm="4">
                  <Label className="label-font" htmlFor="reporterFirst">
                    First Name*
                  </Label>
                  <Field
                    type="text"
                    id="reporterFirst"
                    name="reporterFirstField"
                    className="straighten-borders"
                    value={reporterFirst}
                    onChange={this.setReporterFields}
                    maxLength={50}
                  />
                </Col>
                <Col sm="4">
                  <Label className="label-font" htmlFor="positionCred">
                    Position/Credentials*
                  </Label>
                  <Field
                    type="text"
                    id="positionCred"
                    name="positionCredField"
                    className="straighten-borders"
                    value={positionCred}
                    onChange={this.setReporterFields}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="4">
                  {enableProviderAgency ? 
                    <ResourceSelect
                      label={
                        <>
                          <Label id="providerAgencyField-label" htmlFor="providerAgencyField">
                            Provider Agency Name*
                            <span id="providerAgencyField-help" className="inline-help" />
                          </Label>
                          <div id="providerAgencyNameHelp">
                            <small className='form-text text-muted prov-agency-name-help'>
                              Enter minimum 3 characters and continue to enter to find the exact match.
                            </small>
                          </div>
                          <UncontrolledTooltip target="providerAgencyField-help" placement="right" innerClassName="text-left">
                            Enter minimum 3 characters and continue to enter to find the exact match.
                          </UncontrolledTooltip>
                        </>
                      }
                      id="provAgencyNameId"
                      name="providerAgencyField"
                      className='straighten-borders'
                      placeholder="Select Provider Agency Name"
                      onChange={this.onChangeProvAgencyName}
                      resource={provAgencyNameApi}
                      shouldSearch={(_inputValue) => _inputValue.length > 2}
                      onInputChange={(searchInput) => this.setState({ userInput: searchInput })}
                      parameters={{
                        searchKey: `${userInput}`,
                      }}
                      waitUntilFocused
                      getResult={(data) =>
                        data.names.map((val) => ({
                          value: val.id,
                          label: val.name,
                          abbr: val.abbr
                        }))
                      }
                      method='POST'
                    />
								  :
                    <>
                      <Label className="label-font" htmlFor="providerAgency">
                        Provider Agency Name*
                      </Label>
                      <Field
                        type="text"
                        id="providerAgency"
                        name="providerAgencyField"
                        className="straighten-borders"
                        value={providerAgency}
                        onChange={this.setReporterFields}
                        maxLength={100}
                      />
                    </>
                  }
                </Col>
                <Col sm="4">
                  <Label className="label-font" htmlFor="signature">
                    Signature {/* Populate with First and Last name of section - **Not Required** */}
                  </Label>
                  <Field
                    type="text"
                    id="signature"
                    name="signature"
                    className="straighten-borders"
                    value={(reporterFirst && reporterLast) ? `${reporterFirst} ${reporterLast}`: ''}
                    onChange={this.setReporterFields}
                    disabled
                  />
                </Col>
                <Col sm="3">
                  <DateField
                    id="reporterDate"
                    name="reporterDateField"
                    label="Date*"
                    className="straighten-borders"
                    value={reporterDate}
                    onChange={this.setReporterDate}
                    datePickerProps={{
                      showDefaultInputIcon: true,
                      inputIconPosition: 'after',
                      autoComplete: /edg/i.test(userAgent) ? 'autofill-off-edge' : 'off',
                      phrases: {
                        focusStartDate: 'Select Reporter Date'
                      }
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="3">
                  <Label className="label-font" htmlFor="reporterEmail">
                    Email Address*
                  </Label>
                  <Field
                    type="text"
                    name="reporterEmailField"
                    id="reporterEmailField"
                    className="straighten-borders"
                    value={reporterEmail}
                    placeholder='name@domainname.com'
                    onChange={this.setReporterFields}
                  />
                </Col>
                <Col sm="3">
                  <Label className="label-font" htmlFor="reporterPhone">
                    Phone Number*
                  </Label>
                  <Field
                    type="text"
                    name="reporterPhoneField"
                    id="reporterPhoneField"
                    className="straighten-borders"
                    value={reporterPhone}
                    onChange={this.setReporterFields}
                    maxLength={10}
                    aria-label='Reporter Phone Number'
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <CheckboxGroup name="assessmentCheck" value={assessmentCategories} onChange={this.setAssessmentCat}>
                    <Checkbox className='label-font mb-5 no-display' name='assessmentCheck'
                      label={`I, the FCS-SH Provider, worked with my potential enrollee to share accurate information 
                        to the best of my knowledge for the purpose of connecting the potential enrollee to the FCS and AHAH Rental
                        Assistance Program. *`}
                      value="FCS-AHAH_accurate_info"
                    />
                  </CheckboxGroup>
                </Col>
              </Row>
            </div>
            <hr className="mtb-35" />
            <div>
              <div className="d-flex">
              <h5 className="poppinsH5">
                Assessment Supervisor &nbsp;
              </h5>
              <p className="assessmentSupervisor-text">
                  <em>(if applicable)</em>
              </p>
              </div>
              <Row>
                <Col sm="4">
                  <Label className="label-font" htmlFor="supervisorLast">
                    Last Name
                  </Label>
                  <Field
                    type="text"
                    id="supervisorLast"
                    name="supervisorLastField"
                    className="straighten-borders"
                    value={supervisorLast}
                    onChange={this.setSupervisorFields}
                    maxLength={50}
                  />
                </Col>
                <Col sm="4">
                  <Label className="label-font" htmlFor="supervisorFirst">
                    First Name
                  </Label>
                  <Field
                    type="text"
                    id="supervisorFirst"
                    name="supervisorFirstField"
                    className="straighten-borders"
                    value={supervisorFirst}
                    onChange={this.setSupervisorFields}
                    maxLength={50}
                  />
                </Col>
                <Col sm="4">
                  <Label className="label-font" htmlFor="supervisorPosCred">
                    Position/Credentials
                  </Label>
                  <Field
                    type="text"
                    id="supervisorPosCred"
                    name="supervisorPosCredField"
                    className="straighten-borders"
                    value={supervisorPosCred}
                    onChange={this.setSupervisorFields}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="4">
                  <Label className="label-font" htmlFor="superSignature">
                    Signature
                  </Label>
                  <Field
                    type="text"
                    id="superSignature"
                    name="superSignature"
                    className="straighten-borders"
                    value={(supervisorFirst && supervisorLast) ? `${supervisorFirst} ${supervisorLast}` : ''}
                    disabled
                  />
                </Col>
                <Col sm="3">
                  <DateField
                    id="supervisorDate"
                    name="supervisorDateField"
                    label="Date"
                    className="straighten-borders"
                    value={supervisorDate}
                    onChange={this.setSupervisorDate}
                    datePickerProps={{
                      showDefaultInputIcon: true,
                      inputIconPosition: 'after',
                      autoComplete: /edg/i.test(userAgent) ? 'autofill-off-edge' : 'off',
                      phrases: {
                        focusStartDate: 'Select Supervisor Date'
                      }
                    }}
                  />
                </Col>
              </Row>
            </div>
            <hr className="mtb-35" />
            <div>
              <div className="d-flex">
                <h5 className="poppinsH5">
                  Enrollee consent for services
                </h5>
              </div>
              <p className="label-font">
                Please indicate verbal consent in the notes below if signature was not attainable (required if no signature).
              </p>
              <Row>
                <Col sm="4">
                  <Label className="label-font" htmlFor="enrolleeLast">
                    Last Name*
                  </Label>
                  <Field
                    type="text"
                    id="enrolleeLast"
                    name="enrolleeLastField"
                    className="straighten-borders"
                    value={enrolleeLast}
                    onChange={this.setEnrolleeFields}
                    maxLength={50}
                  />
                </Col>
                <Col sm="4">
                  <Label className="label-font" htmlFor="enrolleeFirst">
                    First Name*
                  </Label>
                  <Field
                    type="text"
                    id="enrolleeFirst"
                    name="enrolleeFirstField"
                    className="straighten-borders"
                    value={enrolleeFirst}
                    onChange={this.setEnrolleeFields}
                    maxLength={50}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="3">
                  <DateField
                    id="enrolleeDate"
                    name="enrolleeDateField"
                    label="Date*"
                    className="straighten-borders"
                    value={enrolleeDate}
                    onChange={this.setEnrolleeDate}
                    datePickerProps={{
                      showDefaultInputIcon: true,
                      inputIconPosition: 'after',
                      autoComplete: /edg/i.test(userAgent) ? 'autofill-off-edge' : 'off',
                      phrases: {
                        focusStartDate: 'Select Enrollee Consent Date'
                      }
                    }}
                    placeholder='MM/DD/YYYY'
                    max={moment().format('MM/DD/YYYY')}
                  />
                </Col>
                <Col sm="4">
                  <Label className="label-font" htmlFor="enrolleeSignature">
                    Time Consent Received*
                  </Label>
                  <Field
                    type="time"
                    id="enrolleeConsentReceived"
                    name="enrolleeConsentReceivedField"
                    className="straighten-borders"
                    value={enrolleeConsentReceived}
                    onChange={this.setTimeConsentReceived}
                    aria-label='Enrollee Consent'
                  />
                </Col>
                <Col sm="4">
                  <Label className="label-font" htmlFor="enrolleeSignature">
                    Signature
                  </Label>
                  <Field
                    type="text"
                    id="enrolleeSignature"
                    name="enrolleeSignature"
                    className="straighten-borders"
                    value={(enrolleeFirst && enrolleeLast) ? `${enrolleeFirst} ${enrolleeLast}` : ''}
                    disabled
                  />
                </Col>
              </Row>
              <Row className="mb-0">
                <Col>
                  <CheckboxGroup name="signatureCheck" value={signatureCategories} onChange={this.setSignatureCat}>
                    <Checkbox className='label-font mb-5 no-display' name="signatureCheck"
                      label="I, the potential enrollee, confirm that all answers have been provided to the best of my knowledge. *"
                      value="I, the potential enrollee, confirm that all answers have been provided to the best of my knowledge."
                    />
                    {(memberInfo.isHomeless === 'Yes' && memberInfo.isEnrolleeEligibleForAHAH === 'Yes') &&
                      <Checkbox className='label-font mb-5 no-display' name="signatureCheck"
                        label="I understand that if I am selected for AHAH-RAP the information on this assessment will be shared with the Department of Commerce, landlords, property managers,
                        and/or their third-part administrator solely for the purposes of connecting me to housing that aligns with my preferences and for program
                        monitoring and evaluation. *"
                        value="shared with the Department of Commerce, landlords, property managers, and/or their third-part administrator"
                      />
                    }
                    <Checkbox className="label-font mb-5 no-display" name="signatureCheck" 
                      label="Verbal consent was received from the potential enrollee. Note: Please print and retain this assessment form, signed by the potential enrollee, on file. *" 
                      value="Verbal consent was received from the potential enrollee."
                    />
                  </CheckboxGroup>
                </Col>
              </Row>
              <Row>
                <Col sm="6">
                <Label className="label-font" htmlFor="enrolleeNotes">
                  Notes:
                </Label>
                <Field
                  type="textarea"
                  id="enrolleeNotes"
                  name="enrolleeNotesField"
                  className='straighten-borders form-control form-group textAreaHeightDetails'
                  onChange={this.setEnrolleeFields}
                  value={enrolleeNotes}
                  row="3"
                  col="200"
                  maxLength={500}
                />
                <p className="small text-right mb-0 label-font">500 Character max</p>
                </Col>
              </Row>

              <div className="spacer-64" />
              
            </div>
            <Button type="button" color={"primary"} className={'btn btn-primary buttonBack'} onClick={this.goBack}>
              Back
            </Button>
            <Button type="submit" color={"primary"} className={'btn btn-primary nextBtn'}>
              Next
            </Button>
          </ProgressValidatedForm>
        </div>
        <div className="pb-spacerRem-4" />
      </>
    );
  }
}

export default withNavigate(SignatureComponent);

SignatureComponent.propTypes = {
  navigate: PropTypes.func
};